import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions, State } from './redux';
import { LimitConfiguration } from './components';

type Actions = typeof actions;

type LimitBaseProps = {
  limitConfigurationUpdate: Actions['limitConfigurationUpdate'];
  fieldDisabled: (field: any) => boolean;
};

type Props = State & Actions & { readOnly: boolean };
class ShowLimits extends React.Component<Props, {}> {
  renderGlobalLimit(limitBaseProps: LimitBaseProps) {
    const {
      globalLimit,
      globalLimit: { active },
    } = this.props;

    if (!active) {
      return null;
    }

    const globalLimitProps = {
      ...limitBaseProps,
      ...globalLimit,
    };
    return <LimitConfiguration {...globalLimitProps} name='Global' />;
  }

  renderMembershipLimit(limitBaseProps: LimitBaseProps) {
    const {
      membershipLimit,
      membershipLimit: { active },
    } = this.props;

    if (!active) {
      return;
    }

    const membershipLimitProps = {
      ...limitBaseProps,
      ...membershipLimit,
    };
    return <LimitConfiguration {...membershipLimitProps} name='Per-Membership' />;
  }

  render() {
    const { limitConfigurationUpdate, readOnly } = this.props;

    const limitBaseProps: LimitBaseProps = {
      limitConfigurationUpdate,
      fieldDisabled: () => readOnly,
    };

    return (
      <Box>
        {this.renderGlobalLimit(limitBaseProps)}
        {this.renderMembershipLimit(limitBaseProps)}
      </Box>
    );
  }
}

type MapStateToProps = (state: RootState) => State;
const mapStateToProps: MapStateToProps = ({ offer: { limits } }) => limits;

export default connect(mapStateToProps, actions)(ShowLimits);
